import { combineReducers } from 'redux';

import apiError from './apiError';
import fields from './fields';
import isDragging from './isDragging';
import isReady from './isReady';
import model from './model';
import selectedLanguage from './selectedLanguage';
import translations from './translations';

/**
 * @typedef {{
 *   fields: import('./fields').AuditModelUIDetailsFieldsReducer,
 *   model: import('./model').AuditModelUIDetailsModelReducer,
 *   translations: import('./translations').AuditModelUIDetailsTranslationReducer,
 *   isReady: boolean,
 *   isDragging: boolean,
 *   apiError: string,
 *   selectedLanguage: string,
 * }} AuditModelUIDetailsReducer
 */

export default combineReducers({
  fields,
  model,
  translations,
  isReady,
  isDragging,
  apiError,
  selectedLanguage,
});
